import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations, getNestedTranslation } from '../lib/i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('vivid-language');
    if (saved) return saved;
    const browserLang = navigator.language.split('-')[0];
    return browserLang === 'es' ? 'es' : 'en';
  });

  useEffect(() => {
    localStorage.setItem('vivid-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = useCallback((key) => {
    const translation = getNestedTranslation(translations[language], key);
    return translation || key;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  const getLocalizedField = useCallback((obj, field) => {
    if (!obj) return '';
    const localizedField = `${field}_${language}`;
    return obj[localizedField] || obj[field] || '';
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
